import { ReadonlyVec3, vec3 } from 'gl-matrix';
import { formatColorRgb } from '~/utils/color';
import { PRIMARY_COLOR } from '~/theme/colors';
import { STRUCTURE_NAME_MAX_LENGTH } from '~/domain/services/dicomProcessor';

export interface StructureOption {
    name: string;
    roiNumber: number;
    color?: { R: number; G: number; B: number };
    /** True when the ROI itself is approved or its parent structure set is approved. */
    isApproved: boolean;
}

/** Normalize ROI color to CSS string with fallback */
export const getStructureColor = (color?: {
    R: number;
    G: number;
    B: number;
}): string => (color ? formatColorRgb(color) : PRIMARY_COLOR);

const MARGIN_SUFFIX = '_mrg';

/**
 * Build the default margin structure name from an input name,
 * truncating the base so the result fits within the DICOM
 * 16-character limit.
 */
export function getDefaultMarginName(inputName: string): string {
    const maxBase = STRUCTURE_NAME_MAX_LENGTH - MARGIN_SUFFIX.length;
    return `${inputName.substring(0, maxBase)}${MARGIN_SUFFIX}`;
}

/**
 * Bright green color used for margin/ring preview contours so they
 * stand out clearly against both bright and dark structure colors.
 */
export const getPreviewColor = (_rgb: ReadonlyVec3): vec3 =>
    vec3.fromValues(0.2, 1.0, 0.4);
